import React from 'react';

const FeaturesSection = () => {
  const featuresBgStyle = {
    backgroundImage: `url('/img/shape/features.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };

  return (
    <section className="space-extra-">
      <div className="container">
        <div className="row">

          {/* Feature 1 */}
          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style1">
              <div className="features-bg" style={featuresBgStyle}></div>
              <div className="features-image">
                <img src="/img/features/features-1-1.png" alt="24/7 Availability" />
              </div>
              <div className="features-content">
                <h3 className="features-title">24/7 Availability</h3>
                <p className="features-text">
                  Our cabs are available around the clock, so you can book a ride anytime, anywhere.
                </p>
              </div>
            </div>
          </div>

          {/* Feature 2 */}
          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style1">
              <div className="features-bg" style={featuresBgStyle}></div>
              <div className="features-image">
                <img src="/img/features/features-1-2.png" alt="Experienced Drivers" />
              </div>
              <div className="features-content">
                <h3 className="features-title">Experienced Drivers</h3>
                <p className="features-text">
                  Our professional drivers prioritize your safety and comfort on every trip.
                </p>
              </div>
            </div>
          </div>

          {/* Feature 3 */}
          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style1">
              <div className="features-bg" style={featuresBgStyle}></div>
              <div className="features-image">
                <img src="/img/features/features-1-3.png" alt="Easy Booking" />
              </div>
              <div className="features-content">
                <h3 className="features-title">Easy Booking</h3>
                <p className="features-text">
                  Book your cab effortlessly via our app or website with just a few clicks.
                </p>
              </div>
            </div>
          </div>

          {/* Feature 4 */}
          <div className="col-xl-3 col-md-6 col-sm-6 col-12">
            <div className="features-style1">
              <div className="features-bg" style={featuresBgStyle}></div>
              <div className="features-image">
                <img src="/img/features/features-1-4.png" alt="Affordable Pricing" />
              </div>
              <div className="features-content">
                <h3 className="features-title">Affordable Pricing</h3>
                <p className="features-text">
                  Competitive rates with no hidden charges, offering you the best value for your money.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
